// src/client/components/Stat.tsx
// Compact label/value pair used inside cards (e.g. score-card grid).
// `mono` (default true) renders the value in JetBrains Mono — best for figures.
import type { ReactNode } from 'react';
import styles from './Stat.module.css';

interface Props {
  label: string;
  value: ReactNode;
  big?: boolean;
  mono?: boolean;
}

export default function Stat({ label, value, big = false, mono = true }: Props) {
  const valueCls = [
    styles.value,
    mono && styles.mono,
    big && styles.big,
  ].filter(Boolean).join(' ');
  return (
    <div className={styles.stat}>
      <div className={styles.label}>{label}</div>
      <div className={valueCls}>{value}</div>
    </div>
  );
}
